module.exports = __webpack_public_path__ + "mt-logo-2015.png?c4c53730a5e21d56c8015e70a2b2201f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mt-logo-2015.png
// module id = 639
// module chunks = 0